import axios from "axios";
import { DataGrid, Template } from "devextreme-react";
import {
  Column,
  Editing,
  FilterRow,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Paging,
  Popup,
  Scrolling,
  Selection,
  Sorting,
  Texts,
  ToolbarItem,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SponsorInfoForm from "./SponsorInfoForm";
import { init, updateAll } from "./Redux/sponsorInfo";

import "./index.css";
import { notifyMsg } from "../../../../common/notify";
import NameCell from "./NameCell";
import { invPlan } from "../../../Payment/data";

export default function SponsorInfo(props) {
  const { sales } = props;

  const sponsorInfo = useSelector((state) => state.sponsorInfo);

  const dispatch = useDispatch();

  const formSponsorInfoRef = useRef(null);
  const sponsorInfoGridRef = useRef(null);

  const [contactPersonPopupVisible, setContactPersonPopupVisible] =
    useState(false);

  const [dataSource, setDataSource] = useState();

  useEffect(() => {
    if (sales.contrNo) {
      setDataSource(
        new CustomStore({
          key: ["contrNo", "email"],
          load: async () => {
            const result = await axios.get(
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/sprInfo/${sales.contrNo}`
            );

            return result.data;
          },
          insert: async (values) => {
            await axios
              .post(
                `${
                  process.env.REACT_APP_BECCO_API_URL
                }/api/salesMgmt/sales/info/sprInfo/${
                  sales.contrNo
                }/${sales.contrNo.substring(4, 7)}/${values.email}`,
                values
              )
              .catch(function (error) {
                if (error) {
                  notifyMsg(
                    "에러가 발생했습니다. 관리자에게 문의해주세요.",
                    "error"
                  );
                }
              });
          },
          update: async (key, values) => {
            await axios
              .put(
                `${
                  process.env.REACT_APP_BECCO_API_URL
                }/api/salesMgmt/sales/info/sprInfo/${
                  // sales.contrNo
                  key.contrNo
                  // }/${sales.contrNo.substring(4, 7)}/${key}`,
                }/${sales.contrNo.substring(4, 7)}/${key.email}`,
                values
              )
              .catch(function (error) {
                if (error) {
                  notifyMsg(
                    "에러가 발생했습니다. 관리자에게 문의해주세요.",
                    "error"
                  );
                }
              });
          },
          remove: async (key) => {
            await axios.delete(
              `${
                process.env.REACT_APP_BECCO_API_URL
              }/api/salesMgmt/sales/info/sprInfo/${
                // sales.contrNo
                key.contrNo
                // }/${sales.contrNo.substring(4, 7)}/${key}`
              }/${sales.contrNo.substring(4, 7)}/${key.email}`
            );
          },
        })
      );
    }
  }, [sales.contrNo]);

  const calculateCellValue = (rowData) => {
    return `${rowData.name} ${rowData.pos ? rowData.pos : ``}`;
  };

  const onInitNewRow = () => {
    dispatch(init());

    setContactPersonPopupVisible(true);
  };

  const onEditingStart = (e) => {
    dispatch(
      updateAll({
        ...e.data,
        invRecip: e.data.invRecip == "1" ? true : false,
        action: "update",
      })
    );

    setContactPersonPopupVisible(true);
  };

  const contentRender = useCallback(() => {
    return (
      <SponsorInfoForm
        sponsorInfo={sponsorInfo}
        formSponsorInfoRef={formSponsorInfoRef}
        sales={sales}
      />
    );
  }, [sponsorInfo]);

  const onSaveClick = useCallback(
    (e) => {
      if (formSponsorInfoRef.current.instance.validate().isValid) {
        setContactPersonPopupVisible(false);

        if (sponsorInfo.action == "insert") {
          sponsorInfoGridRef.current.instance
            .getDataSource()
            .store()
            .insert(sponsorInfo)
            .then(() => {
              sponsorInfoGridRef.current.instance.refresh();
            });
        } else {
          sponsorInfoGridRef.current.instance
            .getDataSource()
            .store()
            .update(
              { contrNo: sponsorInfo.contrNo, email: sponsorInfo.email },
              sponsorInfo
            )
            .then(() => {
              sponsorInfoGridRef.current.instance.refresh();
            });
        }
      }
    },
    [sponsorInfo]
  );

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#E2EFDA";
    }
  };

  const nameCellRender = (data) => {
    if (!data.value) {
      return;
    }

    return <NameCell data={data} />;
  };

  return (
    <DataGrid
      id="sponsorInfoGrid"
      ref={sponsorInfoGridRef}
      dataSource={dataSource}
      allowColumnReordering={true}
      allowColumnResizing={true}
      columnResizingMode="widget"
      rowAlternationEnabled={true}
      showBorders={true}
      showRowLines={true}
      showColumnHeaders={true}
      width={"100%"}
      height={"auto"}
      repaintChangesOnly={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      onInitNewRow={onInitNewRow}
      onEditingStart={onEditingStart}
      onCellPrepared={onCellPrepared}
    >
      <GroupPanel visible={true} />
      <Grouping autoExpandAll={true} />
      <Scrolling
        mode={"virtual"}
        rowRenderingMode={"virtual"}
        columnRenderingMode={"virtual"}
        showScrollbar={"always"}
      />
      <HeaderFilter visible={true} />
      <FilterRow visible={true} applyFilter={"auto"} />
      <Paging enabled={false} />
      <Sorting mode={"multiple"} />
      <Selection mode={"single"} />

      <Editing
        refreshMode={"reshape"}
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteMessage={
            "Are you sure want to delete this contact person?"
          }
        />
        <Popup
          visible={contactPersonPopupVisible}
          showTitle={true}
          title={
            sponsorInfo.action == "insert"
              ? "Create a Contact Person"
              : "Edit the Contact Person"
          }
          width={"70vw"}
          height={"auto"}
          showCloseButton={true}
          contentRender={contentRender}
        >
          <ToolbarItem
            widget={"dxButton"}
            toolbar={"top"}
            location={"after"}
            options={{
              icon: "save",
              type: "normal",
              stylingMode: "contained",
              onClick: onSaveClick,
            }}
          />
        </Popup>
      </Editing>

      <Template name="name" render={nameCellRender} />

      <Column
        dataField={"name"}
        caption={"Contact Person"}
        dataType={"string"}
        calculateCellValue={calculateCellValue}
        cellTemplate={"name"}
      />
      <Column dataField={"role"} caption={"Role"} dataType={"string"} />
      <Column dataField={"tel"} caption={"Telephone"} dataType={"string"} />
      <Column dataField={"mob"} caption={"Mobile"} dataType={"string"} />
      <Column dataField={"email"} caption={"Email"} dataType={"string"} />
    </DataGrid>
  );
}
